import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

const DEFAULT_TIMELINE_HEIGHT = 2;
const HOVERED_TIMELINE_HEIGHT = 4;

const TimelineDiv = styled.div<{
  isHovered: boolean;
  isRespectivePageHovered: boolean;
}>`
  background: ${tokens.color.neutral_500};
  background-clip: content-box;
  bottom: ${({ isRespectivePageHovered }) => (isRespectivePageHovered ? -1 : -5)}px;
  border-radius: 4px;
  box-shadow: 0px 0px 0px 1px ${tokens.color.text_default};
  cursor: pointer;
  box-sizing: border-box;
  height: ${({ isHovered }) => (isHovered ? HOVERED_TIMELINE_HEIGHT : DEFAULT_TIMELINE_HEIGHT)}px;
  overflow: hidden;
  position: absolute;
  transition: all 0.1s ease-out;
  transform-origin: center;
`;

const TProgressBarDiv = styled.div<{ isHovered: boolean }>`
  background: ${tokens.color.ember_600};
  height: ${({ isHovered }) => (isHovered ? HOVERED_TIMELINE_HEIGHT : DEFAULT_TIMELINE_HEIGHT)}px;
  width: 100%;
  transform-origin: top left;
`;

interface Props {
  xPositionInPx: number;
  xWidthInPx: number;
  xProgressInPercent: number;
  isHovered: boolean;
  isRespectivePageHovered: boolean;
}

export const MiniTimeline = ({
  xPositionInPx,
  xWidthInPx,
  xProgressInPercent,
  isHovered,
  isRespectivePageHovered,
}: Props): JSX.Element => {
  return (
    <TimelineDiv
      draggable="false"
      data-testid="mini-timeline"
      style={{
        left: xPositionInPx,
        width: xWidthInPx,
        zIndex: Math.round(xPositionInPx),
      }}
      isHovered={isHovered}
      isRespectivePageHovered={isRespectivePageHovered}
    >
      <TProgressBarDiv
        style={{
          transform: `scaleX(${xProgressInPercent / 100})`,
        }}
        isHovered={isHovered}
      />
    </TimelineDiv>
  );
};
